module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login",
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "user-login-5"
  }, [_c('div', {
    staticClass: "row bs-reset"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 login-container bs-reset mt-login-5-bsfix"
  }, [(!_vm.forgotPassword) ? _c('div', {
    staticClass: "login-content"
  }, [_c('h1', [_vm._v("UNOapp Commerce Login")]), _vm._v(" "), _c('form', {
    staticClass: "login-form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage.length),
      expression: "errorMessage.length"
    }],
    ref: "errorMessage",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    ref: "email",
    staticClass: "form-control form-control-solid placeholder-no-fix form-group",
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.focusPassword($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    ref: "password",
    staticClass: "form-control form-control-solid placeholder-no-fix form-group",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1, false, false)])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 bs-reset mt-login-5-bsfix"
  }, [_c('div', {
    staticClass: "login-bg"
  }, [_c('img', {
    staticClass: "login-logo",
    attrs: {
      "src": require("../assets/img/app/unoapp-commerce-logo.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn green",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33e4a087"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 696
// module chunks = 0